
import React from "react";
import { Check, AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface AdminStatusProps {
  adminStatus: {
    isAdmin: boolean;
    email: string | null;
  } | null;
}

export const AdminStatus = ({ adminStatus }: AdminStatusProps) => {
  if (!adminStatus) return null;

  return (
    <Alert variant={adminStatus.isAdmin ? "default" : "destructive"} className="mb-6">
      <div className="flex items-center gap-2">
        {adminStatus.isAdmin ? (
          <Check className="h-4 w-4" />
        ) : (
          <AlertCircle className="h-4 w-4" />
        )}
        <AlertTitle>Admin Status</AlertTitle>
      </div>
      <AlertDescription>
        {adminStatus.isAdmin 
          ? `You (${adminStatus.email}) are confirmed as an admin user.` 
          : `You (${adminStatus.email}) do not have admin privileges.`}
      </AlertDescription>
    </Alert>
  );
};
